import QCErrorSummaryTable from './QCErrorSummaryTable';
export default QCErrorSummaryTable;
